export const STATUS = {
  SUCCESS: 'success',
}
